import templateUrl from "emun.customer/customer-vendor-details.htm";
import controller from "emun.customer/customer-vendor-details.controller";

export default {
  bindings: {
    customer: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
